import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';


const IndependentTaxFilersModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                independentTaxFilers,
                callbacks
            }
        },
        modalHeaderProps,
        modalHeaderProps: {
            modalId
        }
    } = props;

    const [ theOnlyOneITFName ] = independentTaxFilers;

    const handleHideClick = () => {
        hideAllModals();
    };

    const handleSave = () => {
        callbacks.forEach(cb => cb());
        hideAllModals();
    };

    const getContent = () => {
        const notifications = [
            'modals.itf.you_indicated',
            'modals.itf.itfs_considered',
            'modals.itf.1095-A_generated',
            'modals.itf.other_members_not_be_permitted'
        ];
        return notifications.map(notification => {
            const notificationId = notification.split('.').pop();
            return (
                <span data-testid={`${modalId}-${notificationId}`} key={notification}>
                    <FormattedMessage
                        id = { notification }
                        values = {{
                            theOnlyOneITFName: <strong>{ theOnlyOneITFName }</strong>,
                            ITFQty: independentTaxFilers.length
                        }}
                        tagName = 'p'
                    />
                </span>
            );
        });
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader
                    { ...modalHeaderProps }
                    closeAllModals
                    hideAllModals={hideAllModals}
                />
            </div>
            <div id = 'independentTaxFilersModal' className="gi-modal__body">
                {
                    getContent()
                }
            </div>
            <div className="gi-modal__footer">
                <div className='grid-row controls'>
                    <div className='grid-offset-4 txt-left'>
                        <Button
                            className='usa-button usa-button--outline gi-button gi-button__outline'
                            data-testid={`${modalId}-cancel_btn`}
                            onClick={handleHideClick}
                        >
                            <FormattedMessage id='button.cancel'/>
                        </Button>
                        <Button
                            className='usa-button gi-button gi-button__primary'
                            data-testid={`${modalId}-save_btn`}
                            onClick={handleSave}
                            inputRef={boundAnchor(anchor_1)}
                        >
                            <FormattedMessage id='button.save'/>
                        </Button>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};

export default IndependentTaxFilersModal;
